import React, { useState, useEffect, useRef, Fragment } from "react";
import * as _ from "lodash";
import "../AFReadyDisigen/invoiceprint.css"
import { stylePadding, stylePaddingHead, WaterMarkImage, WaterMarkName } from "../ShareFunctionsPrint";
import Header from "./A4/Header";
import Body from "./A4/Body";
import Footer from "./A4/Footer";
import FooterLast from "./A4/FooterLast";

function HeadersNew(props) {
    const { locInv, found, sta, premiApp } = props;
    return (
        <div style={stylePaddingHead}>
            <Header locInv={locInv} sta={sta ?? {}} info={found} premiApp={premiApp} />
        </div>
    );
}
function BodyInvoice(props) {
    const {  chunk ,num} = props;
    return (
        <div style={stylePadding}>
            <Body data={chunk ?? []} num={num} />
        </div>
    );
}

function Footers(props) {
    const { found, inv, sta, locInv } = props;
    return (
        <div className="footerview" style={stylePadding}>
            <Footer InvForFatora={inv} found={found} sta={sta ?? {}} locInv={locInv}  />
        </div>
    );
}

function TempleteInvCon(props) {
    const { locInv, found, sta, inv, data, premiApp } = props;
    const headerRef = useRef(null);
    const footerRef = useRef(null);
    const totalsRef = useRef(null);
    const rowRefs = useRef([]);
    const [pages, setPages] = useState([]);
    const num  = Number(locInv?.largeNum);


    useEffect(() => {
        const calcutepages = async () => {
            if (document.fonts) await document.fonts.ready;
            const PAGE_HEIGHT = 1120;
            const HEADER1 = headerRef.current?.offsetHeight || 0;
            const FOOTER1 = footerRef.current?.offsetHeight || 0;
            const totalsH = totalsRef.current?.offsetHeight || 0;
            const max_Height = PAGE_HEIGHT - (HEADER1 + FOOTER1 + 20);
            const heights = rowRefs.current.map(el => el?.offsetHeight || 0);

            let pageInvoice = [];
            let currentPage = [];
            let currentHeight = 0;

            data.forEach((item, i) => {
                const rowHieght = heights[i];
                if (currentHeight + rowHieght > max_Height) {
                    pageInvoice.push(currentPage);
                    currentPage = [];
                    currentHeight = 0;
                }
                currentPage.push(item);
                currentHeight += rowHieght;
            });

            if (currentHeight + totalsH > max_Height) {
                pageInvoice.push(currentPage);
                pageInvoice.push([]);
            } else {
                pageInvoice.push(currentPage);
            }
            setPages(pageInvoice);
        };
        calcutepages();
    }, [data]);
    return (
        <>
            <div className="measurecon" >
                <div ref={headerRef}>
                    <HeadersNew locInv={locInv} sta={sta ?? {}} found={found} premiApp={premiApp} />
                </div>
                {data.map((item, i) => (
                    <div key={i}
                        ref={(el) => (rowRefs.current[i] = el)}
                        className="measurerow2"
                    >
                        {item.nameEng!=""?item.symbol: item.notesall}
                    </div>
                ))}
                <div ref={totalsRef}>
                    <FooterLast InvForFatora={inv} found={found} sta={sta ?? {}} locInv={locInv} premiApp={premiApp} />
                </div>
                <div ref={footerRef}>
                    <Footers inv={inv} found={found} sta={sta ?? {}} locInv={locInv} premiApp={premiApp} />
                </div>
            </div>
            <div className="invoicepreview">
                {pages.map((page, i) => (
                    <div className="pageinv" key={i}>
                            {premiApp.billTemplate === 23 ? <WaterMarkName found={found} /> : <WaterMarkImage found={found} />}
                            <div className="contentview">
                                <HeadersNew locInv={locInv} sta={sta ?? {}} found={found} premiApp={premiApp} />
                                <BodyInvoice chunk={page ?? []} num={num} />
                            </div>
                            {i == pages.length - 1 &&
                                    <FooterLast InvForFatora={inv} found={found} sta={sta ?? {}} locInv={locInv} num={num} />}
                            <Footers inv={inv} found={found} sta={sta ?? {}} locInv={locInv} />
                    </div>
                ))}
            </div>
        </>
    );
}
export default TempleteInvCon;
